// Imports
import styled from "styled-components"

import { Variables, Mixins } from "fajny-react"

const Container = styled.div`
    border: 1px solid ${Variables.Colors.Gray200};
    border-radius: ${Variables.Radiuses.L};
    padding: ${Variables.Spacers.S};
`

const StyledButton = styled.a`
    justify-self: start;

    border: 1px solid transparent;
    text-decoration: none;
    padding: ${Variables.Spacers.XS} ${Variables.Spacers.S};
    ${Mixins.Flexbox({
        $inline: true,
        $align: "center",
        $justify: "center",
        $gap: "xs",
    })};
    border-radius: ${Variables.Radiuses.M};
    background-color: ${Variables.Colors.Primary500};
    color: ${Variables.Colors.White};

    &:hover {
        background-color: ${Variables.Colors.Primary300};
    }

    &:active {
        background-color: ${Variables.Colors.Primary600};
    }
`

export { Container, StyledButton }
